export default{
  setEvents(state, events){
    state.events = events
  },
  setEventsSkillsApi(state, errorEventsAPI){
    state.errorEventsAPI = errorEventsAPI
  }
}